import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="main-footer z-1 rel bg-dark-blue text-white pt-50">
        <div className="container">
          <div className="location-social pt-40 pb-10">
            <div className="location wow fadeInRight delay-0-2s">
              <i className="fas fa-map-marker-alt" />
              <h5>123 Innovation Drive, Tech Hub, Silicon Valley</h5>
            </div>
            <div className="social-style-one mb-10 wow fadeInLeft delay-0-2s">
              <a href="#">
                <i className="fab fa-twitter" />
              </a>
              <a href="#">
                <i className="fab fa-facebook-f" />
              </a>
              <a href="#">
                <i className="fab fa-linkedin-in" />
              </a>
              <a href="#">
                <i className="fab fa-youtube" />
              </a>
              <a href="#">
                <i className="fab fa-behance" />
              </a>
              <a href="#">
                <i className="fab fa-instagram" />
              </a>
            </div>
          </div>
          <div className="call-to-action text-center pt-70 pb-80 wow fadeInUp delay-0-4s">
            <div className="section-title mb-20">
              <div>
                <Link to="/">
                  <img
                    src="https://attherate.dev/host-image/uploads/1760377263_ScriptEcho-white__2_.png"
                    alt="Logo"
                    title="Logo"
                  />
                </Link>
              </div>
            </div>
            <p>
              Transform your design workflow with our cutting-edge AI
              technology. Convert UI/UX designs to clean, responsive code
              instantly. Join thousands of developers and designers who have
              revolutionized their development process.
            </p>
          </div>
          <div className="copyright-area pt-25 pb-15">
            <ul className="footer-menu py-5">
              <li>
                <a href="#home">home</a>
              </li>
              <li>
                <a href="#about">About</a>
              </li>
              <li>
                <a href="#pricing">pricing</a>
              </li>
            </ul>
            <p>Copyright @2025 qoll All Rights Reserved</p>
          </div>
        </div>
        <div className="footer-left-circles wow customSlideInLeft delay-0-5s" />
      </footer>
    </>
  );
};

export default Footer;
